import React, { Component, HTMLAttributes, Ref } from "react";
import mergeRefs from "merge-refs";

import { duration } from "@formant/core/model/duration";

interface IMeasureProps {
    onMeasureResize: (width: number, height: number) => void;
    dimension?: IMeasureDimension;
    innerRef?: Ref<HTMLDivElement>;
}

export type IMeasureDimension = "client" | "offset" | "scroll";

const measures = new Set<Measure>();

setInterval(() => measures.forEach(_ => _.measure()), 0.5 * duration.second);

export class Measure extends Component<
    IMeasureProps & HTMLAttributes<HTMLDivElement>
> {
    private ref?: HTMLElement;
    private width: number = 0;
    private height: number = 0;

    public componentDidMount() {
        measures.add(this);
    }

    public measure() {
        const { dimension, onMeasureResize } = this.props;
        const { ref } = this;
        if (!ref) {
            return;
        }

        const width =
            (dimension === "offset" && ref.offsetWidth) ||
            (dimension === "scroll" && ref.scrollWidth) ||
            ref.clientWidth;

        const height =
            (dimension === "offset" && ref.offsetHeight) ||
            (dimension === "scroll" && ref.scrollHeight) ||
            ref.clientHeight;

        if (this.width !== width || this.height !== height) {
            this.width = width;
            this.height = height;
            onMeasureResize(width, height);
        }
    }

    public componentWillUnmount() {
        measures.delete(this);
    }

    public render() {
        const { dimension, onMeasureResize, innerRef, children, ...props } =
            this.props;

        return (
            <div ref={mergeRefs(this.setRef, innerRef)} {...props}>
                {children}
            </div>
        );
    }

    private setRef = (element: HTMLDivElement | null) => {
        this.ref = element || undefined;
    };
}
